import styled from 'styled-components';

import { beam } from '@styles/colors/themes';
import { deviceTypes } from '@styles/mediaQueries';
import { ReactComponent as LogoExpandedImage } from '@assets/svg/standard-logo.svg';
import { ReactComponent as Loader } from '@assets/svg/loader.svg';
import { sizeFromRoller } from '@components/LoadMoreComponent/sizeFromRoller';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  font-size: 48px;
  color: ${beam.font.primary};
  align-items: center;
  align-content: center;
  justify-items: center;
  flex-direction: row;
  justify-content: center;
  column-gap: 32px;
  [data-device='${deviceTypes.mobile}'] & {
    column-gap: 17px;
  }
`;

export const Logo = styled(LogoExpandedImage)`
  display: block;
  width: 300px;
  height: 300px;

  [data-device='${deviceTypes.mobile}'] & {
    width: 100px;
    height: 28px;
  }
`;
export const LoadingImg = styled(Loader)`
  height: ${sizeFromRoller(40)}px;
  width: ${sizeFromRoller(40)}px;
  [data-device='${deviceTypes.mobile}'] & {
    width: unset;
    height: ${sizeFromRoller(22)}px;
  }

  #loader-static-arc {
    fill: transparent;
  }
  #loader-spinning-arc {
    fill: var(--beam-color-blue-b600);
  }
`;

export const LoadingImg2 = styled.img`
  height: 40px;
  width: 40px;
  [data-device='${deviceTypes.mobile}'] & {
    width: unset;
    height: 22px;
  }
`;
